export const OHL = {
    name: 'DV 128/1',
    voltage: '110',
    regionCode: 'BR',
    stanice: [],
    phasesAreConstant: false,
    phases: [ { name: 0, positionIPS: 'Left', position: 'S' }, { name: 4, positionIPS: 'Middle', position: null }, { name: 8, positionIPS: 'Right', position: 'N' } ],
    phaseCross: [
        { 
            name: '4 - 5', 
            position: [{  lat: 44.3915 , lng: 21.9274 }, { lat: 44.3897 , lng: 21.9254 }], 
            OHLs: ['DV 401/2'], 
            phases: [
                { phase: 0, position1: 'Left', position2: 'Middle' }, 
                { phase: 4, position1: 'Middle', position2: 'Right' },
                { phase: 8, position1: 'Right', position2: 'Left' }
            ]
        }],
    stubovi: [
        { index: 1, name: 'P-03', lat: 44.3956 , lng: 21.9333, sys: 1, portal: true },
        { index: 2, name: '1', lat: 44.3952 , lng: 21.9331, sys: 1},
        { index: 3, name: '2', lat: 44.3942 , lng: 21.9311, sys: 1},
        { index: 4, name: '3', lat: 44.3933 , lng: 21.9292, sys: 1},
        { index: 5, name: '4', lat: 44.3915 , lng: 21.9274, sys: 1},
        { index: 6, name: '5', lat: 44.3897 , lng: 21.9254, sys: 1},
        { index: 7, name: '6', lat: 44.3879 , lng: 21.9234, sys: 1},
        { index: 8, name: '7', lat: 44.3853 , lng: 21.9206, sys: 1},
        { index: 9, name: '8', lat: 44.3847 , lng: 21.9189, sys: 1},
        { index: 10, name: '9', lat: 44.3841 , lng: 21.9168, sys: 1},
        { index: 11, name: '10', lat: 44.3832 , lng: 21.9139, sys: 1},
        { index: 12, name: '11', lat: 44.3825 , lng: 21.9114, sys: 1},
        { index: 13, name: '12', lat: 44.3823 , lng: 21.9108, sys: 1},
        { index: 14, name: '13', lat: 44.3788 , lng: 21.908, sys: 1},
        { index: 15, name: '168/3z', lat: 44.3781 , lng: 21.9075, sys: 1},
        { index: 16, name: '168/2z', lat: 44.3778 , lng: 21.9074, sys: 1},
        { index: 17, name: '168/1z', lat: 44.3753 , lng: 21.9066, sys: 1},
        // { index: 15, name: '168/3z', lat: 44.3781 , lng: 21.9075, sys: 2},
        // { index: 16, name: '168/2z', lat: 44.3778 , lng: 21.9074, sys: 2},
        // { index: 17, name: '168/1z', lat: 44.3753 , lng: 21.9066, sys: 2},
        { index: 18, name: 'P-02', lat: 44.3749 , lng: 21.906, sys: 1, portal: true }
    ],
    rasponi: [
        { name: 'P-03 - 1', position: [{ lat: 44.3956 , lng: 21.9333 }, { lat: 44.3952 , lng: 21.9331 }] },
        { name: '1 - 2', position: [{ lat: 44.3952 , lng: 21.9331 }, { lat: 44.3942 , lng: 21.9311 }] },
        { name: '2 - 3', position: [{ lat: 44.3942 , lng: 21.9311 }, { lat: 44.3933 , lng: 21.9292 }] },
        { name: '3 - 4', position: [{ lat: 44.3933 , lng: 21.9292 }, { lat: 44.3915 , lng: 21.9274 }] },
        { name: '4 - 5', position: [{ lat: 44.3915 , lng: 21.9274 }, { lat: 44.3897 , lng: 21.9254 }] },
        { name: '5 - 6', position: [{ lat: 44.3897 , lng: 21.9254 }, { lat: 44.3879 , lng: 21.9234 }] },
        { name: '6 - 7', position: [{ lat: 44.3879 , lng: 21.9234 }, { lat: 44.3853 , lng: 21.9206 }] },
        { name: '7 - 8', position: [{ lat: 44.3853 , lng: 21.9206 }, { lat: 44.3847 , lng: 21.9189 }] },
        { name: '8 - 9', position: [{ lat: 44.3847 , lng: 21.9189 }, { lat: 44.3841 , lng: 21.9168 }] },
        { name: '9 - 10', position: [{ lat: 44.3841 , lng: 21.9168 }, { lat: 44.3832 , lng: 21.9139 }] },
        { name: '10 - 11', position: [{ lat: 44.3832 , lng: 21.9139 }, { lat: 44.3825 , lng: 21.9114 }] },
        { name: '11 - 12', position: [{ lat: 44.3825 , lng: 21.9114 }, { lat: 44.3823 , lng: 21.9108 }] },
        { name: '12 - 13', position: [{ lat: 44.3823 , lng: 21.9108 }, { lat: 44.3788 , lng: 21.908 }] },
        { name: '13 - 14', position: [{ lat: 44.3788 , lng: 21.908 }, { lat: 44.3781 , lng: 21.9075 }] },
        { name: '14 - 15', position: [{ lat: 44.3781 , lng: 21.9075 }, { lat: 44.3778 , lng: 21.9074 }] },
        { name: '15 - 16', position: [{ lat: 44.3778 , lng: 21.9074 }, { lat: 44.3753 , lng: 21.9066 }] },
        { name: '16 - P-02', position: [{ lat: 44.3753 , lng: 21.9066 }, { lat: 44.3749 , lng: 21.906 }] }
    ]
}
